import React from "react";
import {
  Hamburger,
  HamburgerLink,
  HamburgerDropdown
} from "discover.medical.react-component-library";
import {
  getIndicatorIndex,
  getLinkProps
} from "../../../../utils/navigationHelper";
import { StyledNavItem } from "./styled";

export const HamburgerMenu = ({
  isOpen,
  setOpen,
  links,
  pathname,
  eventBus
}) => {
  const closeMenu = () => {
    if (isOpen) {
      setOpen(false);
    }
  };

  return (
    <Hamburger
      isOpen={isOpen}
      onClickOutside={closeMenu}
      indicatorIndex={getIndicatorIndex(links, pathname)}
    >
      {links.map((link) => {
        const { onClick: linkOnClick, ...linkProps } = getLinkProps(
          link,
          links,
          pathname,
          {
            eventBus
          }
        );

        return link.options && link.options.isDropdown ? (
          <HamburgerDropdown
            text={
              <StyledNavItem dangerouslySetInnerHTML={{ __html: link.label }} />
            }
          >
            {link.options.dropdownItems &&
              link.options.dropdownItems.map((dropdownLink) => {
                const { onClick: dropdownLinkOnClick, ...dropdownLinkProps } =
                  getLinkProps(dropdownLink, links, pathname, {
                    eventBus
                  });

                return (
                  <HamburgerLink
                    key={dropdownLink.id}
                    text={
                      <StyledNavItem
                        dangerouslySetInnerHTML={{ __html: dropdownLink.label }}
                      />
                    }
                    onClick={(e) => {
                      dropdownLinkOnClick(e);
                      closeMenu();
                    }}
                    {...dropdownLinkProps}
                  />
                );
              })}
          </HamburgerDropdown>
        ) : (
          <HamburgerLink
            key={link.id}
            text={
              <StyledNavItem dangerouslySetInnerHTML={{ __html: link.label }} />
            }
            onClick={(e) => {
              linkOnClick(e);
              closeMenu();
            }}
            {...linkProps}
          />
        );
      })}
    </Hamburger>
  );
};

HamburgerMenu.defaultProps = {
  links: []
};

export default HamburgerMenu;
